var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAverageResponseTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Average_Response_Time"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Average_Response_Time",
    "data-name": "Average Response Time",
    clipPath: "url(#clip-Average_Response_Time)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M24.741,28H9.571a3.571,3.571,0,0,0,0,7.143H37.849A54.532,54.532,0,0,1,24.741,28Z",
    transform: "translate(10.286 66.857)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M18.947,25H7.571a3.571,3.571,0,1,0,0,7.143H25.532A55.063,55.063,0,0,1,18.947,25Z",
    transform: "translate(5.143 59.143)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M17.635,22H5.571a3.571,3.571,0,1,0,0,7.143H21.539A54.638,54.638,0,0,1,17.635,22Z",
    transform: "translate(0 51.429)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M57.116,49.946a13.04,13.04,0,0,0-12.505,9.159A36.109,36.109,0,0,1,23.179,37.677a13.04,13.04,0,0,0,9.16-12.507A13.17,13.17,0,0,0,6,25.17,51.174,51.174,0,0,0,57.116,76.286a13.17,13.17,0,1,0,0-26.339Z",
    transform: "translate(10.286 25.714)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M65.935,19.4A3.54,3.54,0,0,0,70.1,13.761l-3.571-3.571a3.57,3.57,0,0,0-5.05,0,3.528,3.528,0,0,0-.59,4.162L57.975,17.26a28.355,28.355,0,0,0-11.832-4.3V9.143h3.571a3.571,3.571,0,0,0,0-7.143H35.429a3.571,3.571,0,0,0,0,7.143H39v3.819a28.356,28.356,0,0,0-11.832,4.3l-2.909-2.909a3.528,3.528,0,0,0-.59-4.162,3.57,3.57,0,0,0-5.05,0l-3.571,3.571A3.531,3.531,0,0,0,19.208,19.4l2.466,2.466a28.571,28.571,0,1,0,41.8,0Zm1.637,21.885a25,25,0,1,1-25-25A25.027,25.027,0,0,1,67.571,41.286Z",
    transform: "translate(30.857)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M55.221,30.149a1.786,1.786,0,1,1,0-3.571H58.7A21.442,21.442,0,0,0,39.149,7.025v3.481a1.786,1.786,0,1,1-3.571,0V7.025A21.443,21.443,0,0,0,16.025,26.578h3.481a1.786,1.786,0,1,1,0,3.571H16.025A21.443,21.443,0,0,0,35.578,49.7V46.221a1.786,1.786,0,0,1,3.571,0V49.7A21.443,21.443,0,0,0,58.7,30.149ZM49.34,18.912l-8.581,8.581a3.438,3.438,0,0,1,.176.871,3.571,3.571,0,1,1-3.571-3.571,3.438,3.438,0,0,1,.871.176l8.581-8.581a1.786,1.786,0,0,1,2.525,2.525Z",
    transform: "translate(36.065 12.922)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageResponseTime);
export default __webpack_public_path__ + "static/media/average-response-time.d387e72933ed096bab6202e3f9fc9aac.svg";
export { ForwardRef as ReactComponent };